import { logger } from '../utils/logger';
import { authAxios } from '../utils/apiConfig';

const landingAxios = authAxios;

export async function submitLandingForm(
  email,
  niche,
  name,
  agencyName,
  { prospectUrl, agencyUrl, scheduledTime, phone, smsConsent, smsConsentText } = {},
) {
  // Basic input validation
  if (!email || !email.includes('@')) {
    throw new Error('Invalid email format');
  }

  if (!niche || niche.length > 100) { // Prevent extremely long inputs
    throw new Error('Please enter your business type and location (e.g., "Local Restaurant - East Village", "Auto Repair Shop - Nashville", or "HVAC Service - Atlanta")');
  }

  try {
    const body = {
      email: email.trim().toLowerCase(), // Sanitize email
      niche: niche.trim(), // Sanitize niche
    };
    if (name) {
      body.name = name.trim();
    }
    if (agencyName) {
      body.agency_name = agencyName.trim();
    }
    if (prospectUrl) {
      body.prospect_url = prospectUrl.trim();
    }
    if (agencyUrl) {
      body.agency_url = agencyUrl.trim();
    }
    if (scheduledTime) {
      body.scheduled_time = scheduledTime.trim();
    }
    if (phone) {
      body.phone = phone.trim();
    }
    if (smsConsent) {
      body.sms_consent = true;
      body.sms_consent_text = smsConsentText;
    }
    // The router endpoint, matching the /feedback/landing/* calls in
    // landingMarketService. The bare /landing alias in main.py still forwards
    // here for clients running older JS.
    const response = await landingAxios.post('/feedback/landing', body);
    return response.data;
  } catch (error) {
    logger.error('Landing submission error:', error);
    // Generic error message for users
    throw new Error('Unable to submit form. Please try again later.');
  }
} 